export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo"])},
          "total_number_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["productores"])},
          "total_hectares": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hectáreas"])},
          "destroy_item_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quitar inspector"])},
          "destroy_item_button_message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["¿Estás seguro de que deseas quitar a ", _interpolate(_named("inspector")), " como inspector de ", _interpolate(_named("producer")), "?"])},
          "destroy_item_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        }
      }
    }
  })
}